// src/pages/Legal.jsx
export default function Legal() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-4xl font-bold mb-8 text-blue-900">Mentions Légales</h1>
      
      <div className="bg-white rounded-lg p-8 shadow space-y-6">
        <section>
          <h2 className="text-2xl font-bold mb-4">1. Éditeur du site</h2>
          <p><strong>Raison sociale :</strong> Express Abou Hamama</p>
          <p><strong>Forme juridique :</strong> Entreprise individuelle</p>
          <p><strong>Siège social :</strong> N'Djaména, Quartier Sabangali, Tchad</p>
          <p><strong>Téléphone :</strong> +235 66 12 34 56</p>
          <p><strong>Email :</strong> contact@expressabouhamama.td</p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">2. Conditions d'utilisation</h2>
          <p>La réservation en ligne est soumète à acceptation des présentes conditions...</p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">3. Protection des données</h2>
          <p>Conformément à la loi tchadienne, vos données personnelles sont protégées...</p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">4. Paiement</h2>
          <p>Le paiement en ligne est optionnel. Vous pouvez régler à bord du bus...</p>
        </section>
      </div>
    </div>
  )
}